import {Card} from "@/components/card/Card.tsx";
import {KPICardProps} from "@/components/KPICard/KPICard.types.ts";
import {KPIIcon} from "@/components/KPIIcon/KPIIcon.tsx";
import classNames from "classnames";
import styles from "./KPICard.module.scss";

export const KPICard = ({
  title,
  children,
  icon,
  role,
  onClick,
  className,
  variant = "default",
  valueClassName = styles.valueDefault,
}: KPICardProps) => {
  return (
    <Card
      className={classNames(styles.kPICard, styles[variant], className)}
      variant="kpi"
      role={role}
      onClick={onClick}
    >
      {icon ? <KPIIcon type={icon!} /> : null}
      <div className={classNames(styles.body, {[styles.withoutIcon]: !icon})}>
        <div className={styles.title}>{title}</div>
        <div className={classNames(styles.value, valueClassName)}>{children}</div>
      </div>
    </Card>
  );
};
